import { showNewLayout } from 'src/stores/toDelete/new_layout';
import { get } from 'svelte/store';
import { location, params } from 'svelte-spa-router';

export default function lazyload(el: HTMLElement) {
	const observer = new LazyLoadObserver();
	setTimeout(() => observer.observe(el), 0);
	return {
		destroy() {
			observer.unobserve(el);
		},
	};
}

let instance: LazyLoadObserver;
class LazyLoadObserver {
	private entries: HTMLElement[];
	private rootContainer: HTMLElement;
	private hasScrollListener: boolean = false;
	private bottomBuffer = 20;
	constructor() {
		if (!instance) {
			this.entries = [];
		}
		if (!this.rootContainer || !document.body.contains(this.rootContainer)) {
			if (this.rootContainer) this.rootContainer.removeEventListener('scroll', this.onWinScroll);
			const isDashWidgetList =
				get(showNewLayout) && get(location).indexOf('dash') !== -1 && get(params) !== null;

			this.rootContainer = document.querySelector(
				get(showNewLayout)
					? isDashWidgetList
						? '.dashboard-scroll'
						: '.scroll-content-new-layout'
					: '.scroll.main-layout-scroll',
			);
		}
		return instance;
	}
	public clear = (): void => {
		this.entries = [];
		this.rootContainer.removeEventListener('scroll', this.onWinScroll);
		window.removeEventListener('resize', this.onWinScroll);
		this.hasScrollListener = false;
	};
	public observe = (el: HTMLElement): void => {
		if (this.entries.findIndex((i) => i.id == el.id) == -1) {
			el.style.opacity = '0';
			el.style.transition = 'all .5s';
			if (this.onScrollEl(el, 0)) {
				this.entries.push(el);
				if (!this.hasScrollListener) {
					this.rootContainer.addEventListener('scroll', this.onWinScroll);
					window.addEventListener('resize', this.onWinScroll);
					this.hasScrollListener = true;
				}
			}
		}
	};
	public unobserve = (el: HTMLElement): void => {
		this.entries = this.entries.filter((i) => i.id !== el.id);
		if (!this.entries.length && this.hasScrollListener) this.clear();
	};
	private onWinScroll = (): void => {
		this.entries.forEach((el) => {
			this.onScrollEl(el);
		});
	};
	private onScrollEl = (el: HTMLElement, bottomBuffer = null): boolean => {
		const rect = this.rootContainer.getBoundingClientRect(),
			scrollHeight =
				rect.top + rect.height - (bottomBuffer !== null ? bottomBuffer : this.bottomBuffer),
			posY = el.getBoundingClientRect().top;
		if (rect.height == 0 || scrollHeight >= posY) {
			this.unobserve(el);
			el.style.opacity = '1';
			el.dispatchEvent(new CustomEvent('load'));
			return false;
		}
		return true;
	};
}
